<template>
  <filter-controller
    :receiveSchema="
      hasSchemaResource && schemaProps
        ? schemaProps.receive
        : null
    "
    :schema="
      hasSchemaResource
      && schemaProps
      && schemaProps.result
      && schemaProps.result.items
    "
    :has-schema-resource="hasSchemaResource"
    :receive="allProps.receive"
    :receiveAvailable="availableProps.receive"
    :all="allProps.result && allProps.result.items"
    :available="
      availableProps.result
      && availableProps.result.items
    "
    v-bind="$attrs"
    :loading="
      hasSchemaResource
        ? (
          !!schemaProps
          && schemaProps.loading
          && !(schemaProps.result && schemaProps.result.items)
        )
        : (
          allProps.loading
          && !(allProps.result && allProps.result.items)
        )
    "
    :details-loading="allProps.loading"
    :details-loaded="
      !!(allProps.result && allProps.result.items)
    "
    :available-loading="availableProps.loading"
    :available-loaded="
      !!(
        availableProps.result
        && availableProps.result.items
      )
    "
    :value="value"
    :permanent="permanent"
    @input="handleFilter"
  />
</template>

<script>

import FilterController from './Controller';

export default {
  props: [
    'value',
    'schemaProps',
    'allProps',
    'availableProps',
    'permanent',
    'hasSchemaResource',
  ],

  components: {
    FilterController,
  },

  methods: {
    handleFilter(parameters) {
      this.$emit('input', parameters);
    },
  },
};

</script>

<!-- было:
:loading="allProps.loading || availableProps.loading"
стало:
не блокируем весь UI фильтров из-за загрузки available values
Для отрисовки блока критична только структура фильтров
:loading="allProps.loading && !(allProps.result && allProps.result.items)"
:available-loading="availableProps.loading" -->
